import { FormikProps } from 'formik';
import { isPlainObject, isArray } from 'lodash';

const getFieldWithErrorOnObject = (
  errorObject: Record<string, unknown | unknown[] | Record<string, unknown | unknown[]>>,
) => {
  let fieldName = Object.keys(errorObject)[0];

  if (isPlainObject(errorObject[fieldName])) {
    fieldName = `${fieldName}.${getFieldWithErrorOnObject(errorObject[fieldName] as Record<string, unknown>)}`;
  }
  if (isArray(errorObject[fieldName])) {
    const errorArrayInsideErrorObject = errorObject[fieldName] as unknown[];
    fieldName = `${fieldName}[0]${
      isPlainObject(errorArrayInsideErrorObject[0])
        ? `.${getFieldWithErrorOnObject(errorArrayInsideErrorObject[0] as Record<string, unknown>)}`
        : ''
    }`;
  }
  return fieldName;
};

export function lookoutForErrorsOnFormik<T>(formik: FormikProps<T>): void {
  if (!formik.isSubmitting) return;

  const errorObject = formik.errors;
  const errorsArray = Object.keys(errorObject);

  if (formik.errors && errorsArray.length > 0) {
    const firstErrorKey = errorsArray[0];
    // @ts-ignore formik.errors doesn't accept a key of type string
    const firstErrorField = isPlainObject(errorObject[firstErrorKey])
      ? getFieldWithErrorOnObject(errorObject)
      : firstErrorKey;
    const elementsWithErrorArray = document.getElementsByName(firstErrorField);
    const firstElementWithError = elementsWithErrorArray[0];

    if (firstElementWithError) {
      // Since Safari still doesn't accept the options object
      // for scrollIntoView, remember to add scrollBehavior smooth
      // to the element that wrapps the form
      firstElementWithError.scrollIntoView(false);
      firstElementWithError.focus();
    }
  }
}
